export default "__VITE_PUBLIC_ASSET__09183ad0__"